import RespinWinResult from "model/respin-win-result";
import Record from "slotworks/model/gameplay/records/record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

export class SGRespinGuaranteeResultBuilder implements ResultBuilder {
    public filter(
        record: Record,
        tokens: QuickfireResponse["Tokens"],
        packet: QuickfireResponsePacket
    ): boolean {
        let scatterLanded = false;
        let respinRetrigger = false;
        for (const token of tokens.Token as QuickfireToken[]) {
            if (
                token.attributes.name === "ReSpinAwarded" ||
                token.attributes.name === "WildLandedAward"
            ) {
                respinRetrigger = true;
            }

            if (token.attributes.name === "ScatterLanded") {
                scatterLanded = true;
            }
        }

        // Respins can "stack", so we must also check if there is a pending respin, even if nothing has been won this spin
        if (!scatterLanded && !respinRetrigger) {
            if (packet.Response.Slot.attributes.nextStage === "free_spin_1") {
                respinRetrigger = true;
            }
        }

        return !scatterLanded && respinRetrigger;
    }

    public build(
        record: Record,
        tokens: QuickfireResponse["Tokens"],
        packet: QuickfireResponsePacket
    ): Result[] {
        const isFreespins: boolean = packet.Response.Slot.attributes.stage === "free_spin_2";

        let respinsWon = 1;
        if (isFreespins) {
            const freespinsAwardedTokens = (tokens.Token as QuickfireToken[])
                .filter((token: QuickfireToken) => {
                    return token.attributes.name === "FreeSpinsAwarded";
                });
            if (freespinsAwardedTokens.length > 0) {
                respinsWon = parseInt(freespinsAwardedTokens[0].attributes.value);
            }
        }

        const result: FreespinWinResult | RespinWinResult =
            isFreespins ? new FreespinWinResult() : new RespinWinResult();
        result.freespinsWon = respinsWon;
        return [result];
    }
}

export default new SGRespinGuaranteeResultBuilder();
